import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { LoginComponent } from './components/login/login.component';
import { LoginService } from './services/login.service';
import { ConstsHelper } from '../../helpers/consts.helper';
import { TokenLocalStorageService } from './services/token-local-storage.service';
import { loginReducer } from './store/reducers/login.reducer';
import { refreshTokenReducer } from './store/reducers/refresh.reducer';
import { LoginEffects } from './store/effects/login.effects';
import { RefreshTokenEffects } from './store/effects/refresh-token.effects';
import { CookieService } from 'ngx-cookie-service';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SharedModule } from '../shared/shared.module';
import { ResetLoginComponent } from './components/reset-login/reset-login.component';
import { TogglePasswordService } from './services/toggle-password.service';
import {
    RecaptchaModule,
    RECAPTCHA_SETTINGS,
    RecaptchaSettings,
} from 'ng-recaptcha';
import { FirstConnexionComponent } from './components/first-connexion/first-connexion.component';


@NgModule({
    declarations: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent, ResetLoginComponent, FirstConnexionComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        AuthenticationRoutingModule,
        StoreModule.forFeature(ConstsHelper.REDUCER_LOGIN, loginReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_REFRESH_TOKEN, refreshTokenReducer),
        EffectsModule.forFeature([LoginEffects, RefreshTokenEffects]),
        SharedModule,
        RecaptchaModule
    ],
    providers: [
        TokenLocalStorageService,
        LoginService,
        CookieService,
        TogglePasswordService,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                badge: 'inline',
                size: 'invisible',
            } as RecaptchaSettings,
        },

    ]
})
export class AuthenticationModule { }
